<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex">
        <div class="flex-shrink-0 me-3">
          <div class="avatar align-items-center">
            <div class="avatar-title rounded bg-primary bg-gradient">
              <eva-icon name="gift" class="fill-white font-size-20"></eva-icon>
            </div>
          </div>
        </div>
        <div class="flex-grow-1">
          <h5 class="text-muted mb-1">Abono sin asignar</h5>
          <h4 class="mb-0">
            <router-link
              :to="{
                name: 'facturasPendientesPago',
                params: { id_cliente: idCliente }
              }"
              :class="abonoDisponible <= 0 ? 'text-dark' : ''"
            >
              {{ formatoMoneda(abonoDisponible) }}
            </router-link>
          </h4>
        </div>

        <div class="flex-shrink-0 align-self-end ms-2">
          <span class="badge rounded-pill font-size-12 badge-soft-success">
            Saldo a favor
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClienteSrv from '@/services/ClienteSrv.js'
import accounting from 'accounting/accounting.js'

export default {
  name: 'CmpAbonoSinAsignar',
  props: {
    idCliente: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      baseUrl: window.location.origin,
      abonoDisponible: 0,
    }
  },
  computed: {
    monedaSistema:function(){
      return this.$store.state.todo.moneda_sistema
    }
  },

  created: function() {
    var self = this
    this.refrescarAbonosDisponibles()

    iu.bus.on('abonos-actualizados', function() {
      self.refrescarAbonosDisponibles()
    })
  },
  methods: {
    formatoMoneda: function (numero) {
      return accounting.formatMoney(numero, { symbol: this.monedaSistema.simbolo, miles: ",", decimal: "." })+' '+this.monedaSistema.codigo
    },
    refrescarAbonosDisponibles: function() {
      var self = this

      ClienteSrv.abonoDisponible(self.idCliente).then(response => {
        let abono = response.data
        self.abonoDisponible = abono >= 0 ? abono : 0
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje) : null
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.text-dark:hover {
  color: #3B76E1 !important;
}
</style>
